import type { User as FirebaseUser } from "@firebase/auth";
import { User } from "src/types/user";
import { handleUnauthorizedResponse } from "../api";

export const getUserServerData = async (id: string): Promise<User | false> => {
  const accessToken = localStorage.getItem("access_token");
  try {
    const response = await fetch(
      process.env.REACT_APP_BE_URL +
        `/users/search/?refer=id&key=${encodeURIComponent(id)}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    if (response.status === 401) {
      handleUnauthorizedResponse();
      return false;
    }

    if (response.ok) {
      const data = await response.json();
      return data[0];
    }
    throw new Error("Error parsing user data response object");
  } catch (error) {
    console.error("Error:", error);
    return false;
  }
};

export const createUserIfNotExists = async (user: FirebaseUser) => {
  const accessToken = localStorage.getItem("access_token");
  try {
    const response = await fetch(
      process.env.REACT_APP_BE_URL + `/users/create`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({
          id: user.uid,
          email: user.email,
          name: user.displayName ?? "Unknown",
          avatar: user.photoURL ?? "",
          visualisationSettings: {
            calendarTreshold: "70",
            calendarMultiLineGraphRange: "loose",
          },
        }),
      }
    );

    if (response.status === 401) {
      handleUnauthorizedResponse();
    }

    if (response.ok) {
      if (process.env.NODE_ENV === "development") {
        if (response.ok) {
          console.log("User created or exists:", await response.json());
        } else {
          console.log("User creation/fetch error:", response);
        }
      }
    }
  } catch (error) {
    console.error("Error:", error);
  }
};
